export default __webpack_public_path__ + "static/media/1292.3c151a2c.png";